module.exports = __webpack_public_path__ + "media/images/page/ico_medal1-784c871b9b06254c8253af57af2b62a9.svg";